import useAPI from '@/hooks/useAPI';
import RequestedFormCompletionRepository from '@/repositories/RequestedFormCompletionRepository';
import { QueryParams } from '@/types/query';

export const useRequestedFormCompletions = (params: QueryParams, enabled = true) => {
  const requestedFormCompletionRepository = RequestedFormCompletionRepository();

  return useAPI({
    queryKey: ['getRequestedFormCompletions', params],
    queryFn: async () => {
      return await requestedFormCompletionRepository.getRequestedFormCompletionList(params);
    },
    enabled
  });
};
